import { Component } from '@angular/core';
import { CmSettingsService, PortalCoreFeature } from '@ats/cm/core';

@Component({
    selector: 'cm-dash',
    templateUrl: './cm-dash.component.html',
    styleUrls: ['./cm-dash.component.scss'],
    standalone: false
})
export class CmDashComponent {
	readonly locFeature: PortalCoreFeature;

	constructor(private settings: CmSettingsService) {
		this.locFeature = this.settings.portalCoreFeature;
	}
}
